import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { sans as zoram, fontSize14, lineHeightTight, fontWeightBold } from "../../../../eden-style-constants";
export const internalUseOnlyPriority5 = css(["margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";"], zoram, fontWeightBold, fontSize14, lineHeightTight);
const H5Styled = styled.h5.withConfig({
  componentId: "sc-1k9r0br-0"
})(["", ";"], internalUseOnlyPriority5);

const H5 = ({
  children,
  ...props
}) => /*#__PURE__*/React.createElement(H5Styled, props, children);

export default H5;
H5.propTypes = {
  /** Content inside heading */
  children: PropTypes.node.isRequired
};